/* eslint-disable no-use-before-define */
// no-use-before-define there is no way this can be satisfied using module export syntax

import sharedFunctions from '../shared_functions/shared_functions';

// Clearest example of an equivalent to the previous ajax operation
// https://hashnode.com/post/7-different-ways-to-make-ajax-calls-in-javascript-in-2019-cjr7pi2fl000gdjs2zgssqwhr
const postProxyFormData = (url, formData) => {
  const jsonBody = 'formData=';
  const encodeFormData = jsonBody.concat(encodeURI(JSON.stringify(formData)));

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: encodeFormData,
  });
};

document.addEventListener('submit', (event) => {
  if (event.target.tagName === 'FORM') {
    const formData = sharedFunctions.serializeArray(event.target);
    const url = '/proxylead/';
    proxyFormLead.postProxyFormData(url, formData);
  }
});

const proxyFormLead = {
  postProxyFormData,
};

export default proxyFormLead;
